export default {
  'mainNavigation.dashboard': 'Tableau de bord',
};
